import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Button,
  TextField,
  Typography,
  Link,
  Grid,
  Box,
  Container,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import getTheme from '../theme/theme';
import { toast } from 'react-toastify';
//import { ButtonBase } from '@mui/material';
import { Backdrop, CircularProgress, } from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { useTheme } from '@mui/material/styles';
import { BASEURL, AUTOFILL_STYLES } from "../constants/Common"

const Register: React.FC = () => {
  const theme = getTheme();
  const [username, setUsername] = useState('');
  const [organizationname, setOrganizationname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const [userDetails, setUserDetails] = useState([]);


//   useEffect(() => {
//     const fetchInspections = async () => {
//         try {
//             const user = `${BASEURL}/register-users/`;
//             const response = await axios.get(user , {
//                 headers: {
//                     Accept: 'application/json',
//                 },
//             });
//             console.log("alluserdetails:",response.data);
//             setUserDetails(response.data);
//         } catch (error) {
//             console.log(error);
//         }
//     };
//     fetchInspections();
// }, []); 

// console.log("userDetails:",userDetails);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validateInput = () => {
    //Validate the mandatory fields entered or not
    if (username.length === 0) {
      toast.error("Please enter User name.")
      return false;
    }
    if (organizationname.length === 0) {
      toast.error("Please enter Organzation name.")
      return false;
    }
    if (email.length === 0) {
      toast.error("Please enter Email id.")
      return false;
    }
    if (password.length === 0) {
      toast.error("Please enter password.")
      return false;
    }
    if (confirmPassword.length === 0) {
      toast.error("Please enter Confirmation password.")
      return false;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return false;
    }
    return true;
  }



  const handleRegister = async () => {
    try {

      const ret = validateInput();
      if (!ret)
        return

       // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Invalid email format. Please enter a valid email address');
      return;
    }
      setIsLoading(true);

      // Check if username or email already exists
      const checkResponse = await axios.post(BASEURL + '/check-user-exists/', {
        username,
        organization_name: organizationname,
        email,
       
      });

      if (checkResponse.data.exists) {
        const field = checkResponse.data.field;
        toast.error(`${field.charAt(0).toUpperCase() + field.slice(1)} already exists.`);
        setIsLoading(false);
        return;
      }

      //      const response = await axios.post('http://localhost:8000/register/', {
      const response = await axios.post(BASEURL + '/register/', {
        username,
        organization_name: organizationname,
        email,
        password,
        confirm_password: confirmPassword,
      });

      if (response.status) {
        setRegistrationSuccess(true);
        toast.success('Registration confirmation link has been sent to your email');
      } else {
        toast.error('Registration failed');
      }
    } catch (error: any) {
      toast.error((error as Error).message || 'Something went wrong');
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };


  return (
    <ThemeProvider theme={getTheme()}>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>

      <Container component='main' maxWidth='xs'>
        {registrationSuccess ? (
          <Box
            sx={{
              marginTop: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft: 5,
              marginRight: 5,
              maxWidth: '300px', // Adjust this value as needed
            }}
          >
            <Typography variant='body1' align='center'>
              An email with a link to confirm your registration has been sent. Please access this email and confirm.
            </Typography>
            <RouterLink
              to='/login'
              style={{
                padding: '16px 6px', // Increase padding to create a larger clickable area
                color: 'inherit',
                cursor: 'pointer',
                display: 'inline-block', // Ensure link behaves like a block element
              }}
            >
              Already have an account? Login
            </RouterLink>
          </Box>
        ) : (
          <Box
            sx={{
              marginTop: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <Typography component='h1' variant='h5'>
              Register New Account
            </Typography>
            <Box component='form' noValidate sx={{ mt: 1 }}>
              <TextField
                margin='normal'
                required
                fullWidth
                id='username'
                label='Username'
                name='username'
                autoComplete='username'
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                sx={{
                  height: '20px',
                  marginBottom: 4,
                  ...AUTOFILL_STYLES(theme),
                }}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                id='organizationname'
                label='Organizationname'
                name='organizationname'
                autoComplete='organizationname'
                value={organizationname}
                onChange={(e) => setOrganizationname(e.target.value)}
                sx={{
                  height: '20px',
                  marginBottom: 4,
                  ...AUTOFILL_STYLES(theme),
                }}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                id='email'
                label='Email Address'
                name='email'
                autoComplete='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  height: '20px',
                  marginBottom: 4,
                  ...AUTOFILL_STYLES(theme),        
                }}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                name='password'
                label='Password'
                type={showPassword ? 'text' : 'password'}
                id='password'
                autoComplete='new-password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ height: '20px', marginBottom: 4, ...AUTOFILL_STYLES(theme) }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='toggle password visibility'
                        onClick={handleClickShowPassword}
                        edge='end'
                      >
                        {!showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                name='confirmPassword'
                label='Confirm Password'
                type={showConfirmPassword ? 'text' : 'password'}
                id='confirmPassword'
                autoComplete='new-password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                sx={{ height: '20px', marginBottom: 4, ...AUTOFILL_STYLES(theme),}}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='toggle confirm password visibility'
                        onClick={handleClickShowConfirmPassword}
                        edge='end'
                      >
                        {!showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                type='button'
                fullWidth
                variant='contained'
                sx={{ mt: 3, mb: 1 }}
                onClick={handleRegister}
              >
                Register
              </Button>{' '}
              <br />
              <Grid container justifyContent='flex-end'>
                <Grid item>
                  {/* <ButtonBase
          component={RouterLink}
          to='/login'
          sx={{
            
            padding: '6px', // Increase padding to increase clickable area
          }}
        >
          Already have an account? Login
        </ButtonBase> */}
                  <RouterLink
                    to='/login'
                    style={{
                      padding: '16px 6px', // Increase padding to create a larger clickable area
                      color: 'inherit',
                      cursor: 'pointer',
                      display: 'inline-block', // Ensure link behaves like a block element
                    }}
                  >
                    Already have an account? Login
                  </RouterLink>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default Register;
